module.exports = __webpack_public_path__ + "media/images/pages/peel/peel-1-3a3fe4df4f00875bba947991df531e17.png";